<template>
  <div id="empty-img" v-if="isShow" :style="{backgroundColor:color} ">
    <img src="../../static/images/empty/pg_wushuju@2x.png" alt="">
    <p>暂无数据</p>
  </div>
</template>

<script>
  export default {
    props:{
      isShow:[String,Boolean],
      color:{
        type:String,
        default:'#fff'
      }
    }
  }
</script>

<style lang="less">
  #empty-img{
    img{
      margin-left: 280px;
      margin-top: 120px;
      margin-bottom: 30px;
      width: 150px;
      height: 180px;
    }
    p{
      text-align: center;
      font-size: 32px;
      color: #C3C9CD;
      padding-bottom: 200px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/emptyList.vue